<!--主文件-->
<template>
  <div v-title :data-title="`动态 - 足趣社区`" class="main" v-loading="loading">
    <Header :onDownClick="openApp"/>
    <div v-if="data">
      <div class="content">
        <DynamicUserInfo :data="data.accountInfo" :desc="data.cdate" :anonymous="data.anonymous"/>
        <DynamicContent v-title :data-title="`${data.content} - 足趣社区`" :onDownClick="openApp"
                        :resource="data.resources ? JSON.parse(data.resources) : undefined" :text="data.content"
                        :voice="data.voice"/>
        <div class="gift">
          <DynamicGift :list="data.giverInfo" :total="data.giverTotal"/>
        </div>
      </div>
      <DynamicOperation :browse-number="data.readNumber" :comment-number="data.commentNumber"
                        :like-number="data.likeNumber"/>
      <div class="split"></div>
      <DynamicComment :onDownClick="openApp" v-loading="commentLoading" :list="comments"/>
    </div>
    <Footer/>
  </div>
</template>

<script>
import Header from '../../../components/Header';
import DynamicUserInfo from './UserInfo';
import DynamicContent from './Content';
import DynamicGift from './Gift';
import DynamicOperation from './Operation';
import Footer from '../../../components/Footer.vue';
import DynamicComment from './Comment';
import OpenInstall from "../../../lib/OpenInstall";

export default {
  name: "ShareDynamic",
  components: {
    Header,
    DynamicUserInfo,
    DynamicContent,
    DynamicGift,
    DynamicOperation,
      Footer,
    DynamicComment,
  },
  data: function () {
    return {
      // 动态数据
      data: undefined,
      // 评论数据
      comments: undefined,
      // 动态是否正在加载中
      loading: true,
      // 评论是否正在加载中
      commentLoading: true,
      // shareInstall组件
      shareInstall: undefined,
    }
  },
  created: function () {
    // 先尝试拉起
    OpenInstall.schemeWakeup();

    let dynamicId = this.$route.query.id;

    // 查询动态信息
    this.$axios.post(`/api/user/dynamic/dynamic/queryById/${dynamicId}`).then((res) => {
      this.loading = false;
      if (res.code !== 200) {
        return;
      }
      this.data = res.data;
    });

    // 查询评论信息
    this.$axios.post(`/api/user/user/dynamic-comment/queryAndPage`, {
      dynamicId: dynamicId,
      size: 3,
    }).then((res) => {
      this.commentLoading = false;
      if (res.code !== 200) {
        return;
      }
      this.comments = res.data.records;
    });
  },
  methods: {
    // 打开App
    openApp() {
      this.$router.push({path: "/open", query: this.$route.query});
    },
  }
}
</script>

<style scoped>
.main {
  width: 100%;
  height: 100%;
  font-size: 12px;
  font-family: "Microsoft Yahei", arial, "Hiragino Sans GB", sans-serif;
  max-width: 500px;
  margin: auto;
}

.content {
  padding: 1rem;
}

.gift {
  margin-top: 20px;
}

.split {
  width: 100%;
  height: 1rem;
  background: #eee;
}
</style>
